namespace PaperTrail.NewsletterControl {
    export namespace PermissionKeys {
        export const Dashboard = "Newsletter:Dashboard";
        export const Contributor = "Newsletter:Contributor";
        export const Organizer = "Newsletter:Organizer";
    }
}
